import {WebStorageStateStore} from 'oidc-client-ts';
import type {AuthProviderProps} from 'react-oidc-context';
import {Configuration} from './configuration';

export const authProviderProps: AuthProviderProps = {
  authority: `https://cognito-idp.${Configuration.user.cognitoUserPoolRegion}.amazonaws.com/${Configuration.user.cognitoUserPoolId}`,
  client_id: Configuration.user.cognitoUserpoolClientId,
  redirect_uri: Configuration.user.cognitoLoginCallback,
  response_type: 'code',
  scope: 'email openid profile',
  userStore: new WebStorageStateStore({store: window.localStorage}),
};

export const signOutRedirectProps = {
  clientId: Configuration.user.cognitoUserpoolClientId,
  logoutUri: Configuration.user.cognitoLogoutCallback,
  cognitoDomain: `https://${Configuration.user.cognitoDomain}`,
};
